<span class="d-block">{{ step6.getspan5 | translate }}</span>
<div class="container">
<div class="item">  
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="typeDureeMarche.nbMois" 
 
[label]="step6.getnbmois"
[type]="'number'" [rule]="'min_1|max_999'"
[name]="getUid()+'_SepAtt_nbMois'">
</app-form-input>
</div>
<div class="item">
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="typeDureeMarche.nbJours" 
 
[label]="step6.getnbjours"
[type]="'number'" [rule]="'min_1|max_9999'"
[name]="getUid()+'_SepAtt_nbJours'">
</app-form-input>
</div>
</div>


<span class="d-block">{{ step6.getspan6 | translate }}</span>

<div class="container">
<div class="item">   
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="typeDureeMarche.dateACompterDu" 
 
[label]="step6.getdateacompterdu"
[type]="'date'" [rule]="'pattern_7'"
[errorMessage]="{'pattern' : 'ctr_pattern7'}"
[name]="getUid()+'_SepAtt_dateACompterDu'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>
</div>
<div class="item">
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="typeDureeMarche.dateJusquau" 
 
[label]="step6.getdatejusquau"
[type]="'date'" [rule]="'pattern_7'"
[errorMessage]="{'pattern' : 'ctr_pattern7'}"
[name]="getUid()+'_SepAtt_dateJusquau'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg7" [id]="getStepId() + rg7"></app-form-input-error>
</div>
</div>
<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="typeDureeMarche.dateDebutPrestation" 
 
[label]="step6.getdatedebutprestation"
[type]="'date'" [rule]="'pattern_7'"
[errorMessage]="{'pattern' : 'ctr_pattern7'}"
[name]="getUid()+'_SepAtt_dateDebutPrestation'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="typeDureeMarche.dateDebutTravaux" 
 
[label]="step6.getdatedebuttravaux"
[type]="'date'" [rule]="'pattern_7'"
[errorMessage]="{'pattern' : 'ctr_pattern7'}"
[name]="getUid()+'_SepAtt_dateDebutTravaux'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="typeDureeMarche.txtLibre" 
 
[label]="step6.gettxtlibre"
[type]="'text'" [rule]="'minSize_5|maxSize_2000'"
[name]="getUid()+'_SepAtt_txtLibre'">
</app-form-input>
